/**
 * Auto-generated from dark-roast/api-envoy OpenAPI spec. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { z } from 'zod';
import { calendarManualInterviewRequestDtoSchema } from './calendar-manual-interview-request-dto';

export const clientRequestDtoSchema = z.object({ "calendarManualInterviewRequests": z.array(z.lazy(() => calendarManualInterviewRequestDtoSchema)), "id": z.string().uuid() });
export type ClientRequestDto = z.infer<typeof clientRequestDtoSchema>;
